<nav class="navbar navbar-expand-lg" id="header-var">
    <div class="container-fluid">
        @if (showMobileUi) {
            <span class="navbar-brand">
                <a href="https://www.te05.fr/" target="_blank">
                    <img
                        src="../../../../assets/img/login/csgp_hautes_alpes/logo_te05.png"
                        alt="logo TE05"
                        height="65"
                    />
                </a>
                <a href="https://www.ademe.fr/" target="_blank">
                    <img
                        src="../../../../assets/img/login/csgp_hautes_alpes/logo_ademe.png"
                        alt="logo ademe"
                        height="55"
                    />
                </a>
                <a href="https://fondschaleur.ademe.fr/" target="_blank">
                    <img
                        src="../../../../assets/img/login/csgp_hautes_alpes/logo_fonds_chaleur.png"
                        alt="logo fonds chaleur"
                        height="55"
                    />
                </a>
                <a href="https://lesgenerateurs.ademe.fr/mon-conseiller-en-region/les-generateurs-provence-alpes-cote-dazur-eres-sictiam/" target="_blank">
                    <img
                        src="../../../../assets/img/login/csgp_hautes_alpes/logo_generateurs.png"
                        alt="logo les générateurs"
                        height="55"
                    />
                </a>
                <button
                    *ngIf="!hideDisconnect"
                    class="navbar-toggler"
                    type="button"
                    (click)="isCollapsed = !isCollapsed"
                    data-bs-target="#siterre-navbar-collapse"
                    aria-controls="siterre-navbar-collapse"
                    [attr.aria-expanded]="!isCollapsed"
                    aria-label="Toggle navigation"
                >
                    <!-- <span class="navbar-toggler-icon"></span> -->
                    <i class="bi bi-list"></i>
                </button>
            </span>
        } @else {
            <span class="navbar-brand">
                <a href="https://www.ademe.fr/" target="_blank">
                    <img
                        src="../../../../assets/img/login/csgp_hautes_alpes/logo_ademe.png"
                        alt="logo ademe"
                        height="55"
                    />
                </a>
                <a href="https://fondschaleur.ademe.fr/" target="_blank">
                    <img
                        src="../../../../assets/img/login/csgp_hautes_alpes/logo_fonds_chaleur.png"
                        alt="logo fonds chaleur"
                        height="55"
                    />
                </a>
                <a href="https://lesgenerateurs.ademe.fr/mon-conseiller-en-region/les-generateurs-provence-alpes-cote-dazur-eres-sictiam/" target="_blank">
                    <img
                        src="../../../../assets/img/login/csgp_hautes_alpes/logo_generateurs.png"
                        alt="logo les générateurs"
                        height="55"
                    />
                </a>
            </span>

            <a href="https://www.te05.fr/" target="_blank" class="p-2">
                <img
                    src="../../../../assets/img/login/csgp_hautes_alpes/logo_te05.png"
                    alt="logo TE05"
                    height="60"
                />
            </a>
        }

        <div
            id="siterre-navbar-collapse"
            class="collapse navbar-collapse"
            [ngbCollapse]="isCollapsed"
          >
            <div *ngIf="!hideDisconnect" class="navbar-nav ms-auto mb-lg-0 mt-2 mt-lg-0">
                <stButton
                    btnLabel="Comment ça marche ?"
                    (onClick)="openTutorialModal()"
                    btnClass="btn-header-var text-nowrap"
                    iconSvgRight="csgp-var-tutorial"
                    [iconSvgHeight]="24"
                    [iconSvgWidth]="24"
                    >
                </stButton>
                <stButton
                    class="d-none d-lg-block"
                    btnClass="btn-cta-var logout"
                    (onClick)="logOut()"
                    iconSvgRight="csgp-var-login"
                    [iconSvgHeight]="24"
                    [iconSvgWidth]="24"
                    title="Accueil"
                    >
                </stButton>
                <stButton
                    class="d-block d-lg-none"
                    btnLabel="Accueil"
                    btnClass="btn-header-var text-nowrap"
                    (onClick)="logOut()"
                    iconSvgRight="csgp-var-login"
                    [iconSvgHeight]="24"
                    [iconSvgWidth]="24"
                    title="Accueil"
                    >
                </stButton>
            </div>
        </div>
    </div>
</nav>
